// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardPlaceholder_wrapper__9P-Oh"};